import {
  _post,
  _get,
  getExport
} from './fetch'

/*** 任务管理-新建任务  */
  // 获取表规则菜单
export const articleList = (params) => {
  return _get('/website_service/article/list', params)
}

export const articleListAll = (params) => {
  return _get('/website_service/article/list-all', params)
}

// 获取任务列表
export const loginPwd = (params) => {
  return _post('/website_service/passport/login/pwd', params)
}

export const logout = (params) => {
  return _post('/website_service/passport/logout', params)
}

export const uploadImg = (params) => {
  return _post('/website_service/img/upload', params)
}
// 192.168.102.175:8081/website_service/passport/login/pwd

export const createArticle = (params) => {
  return _post('/website_service/article/create', params)
}

export const updateArticle = (params) => {
  return _post('/website_service/article/update', params)
}

export const delArticle = (params) => {
  return _post('/website_service/article/del', params)
}


// WEBPACK FOOTER //
// ./src/api/index.js